import axios from 'axios';

import {AccountAssignmentInfo} from 'interfaces';

import {API_URL} from './constants';

const sessionResultInformationUrl = `${API_URL}/session-result-information`;

const getFailedSessionResultValues = async (
    assignment?: AccountAssignmentInfo, isRecursive?: boolean
): Promise<string[]> => {
    const response = await axios.post(`${sessionResultInformationUrl}/failed`, {assignment, isRecursive});
    return response.data;
};

const getSuccessSessionResultValues = async (
    assignment?: AccountAssignmentInfo, isRecursive?: boolean
): Promise<string[]> => {
    const response = await axios.post(`${sessionResultInformationUrl}/success`, {assignment, isRecursive});
    return response.data;
};

const saveFailedSessionResultValues = async (assignment: AccountAssignmentInfo, values: string[]): Promise<string[]> => {
    const response = await axios.post(`${sessionResultInformationUrl}/failed/update`, {assignment, values});
    return response.data;
};

const saveSuccessSessionResultValues = async (assignment: AccountAssignmentInfo, values: string[]): Promise<string[]> => {
    const response = await axios.post(`${sessionResultInformationUrl}/success/update`, {assignment, values});
    return response.data;
};

export const sessionResultInformationApi = {
    getFailedSessionResultValues,
    getSuccessSessionResultValues,
    saveFailedSessionResultValues,
    saveSuccessSessionResultValues
};
